import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import properties from '../../api/properties/hooks'
import { MODAL_TYPES } from '../../common/constants'
import { hideModal } from '../../store/modal'

interface CloneModalProps {
    isOpen: boolean
    cloneModal: {
        id: string
        data: string[]
    }
}

const CloneModal = (props: CloneModalProps) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const { mutate: cloneProperty, isPending } = properties.CloneProperty.useMutation()

    const { isOpen, cloneModal } = props
    const { id, data } = cloneModal

    const handleClose = () => dispatch(hideModal({ modalType: MODAL_TYPES.CLONE_MODAL }))

    return (
        <Modal isOpen={isOpen} centered>
            <ModalHeader toggle={handleClose}>
                <p className="m-0">{t('view.property.action.clone')}</p>
            </ModalHeader>
            <ModalBody>
                <div className="d-flex gap-2 justify-content-end mt-4 mb-2">
                    <Button type="button" color="primary" className="btn-label" data-bs-dismiss="modal" onClick={handleClose}>
                        <i className="mdi mdi-close label-icon align-middle fs-16"></i>
                        {t('button.cancel')}
                    </Button>
                    <Button
                        className="btn-label align-self-end"
                        type="submit"
                        color="info"
                        disabled={isPending}
                        onClick={() => cloneProperty({ id, data }, { onSuccess: () => handleClose() })}
                    >
                        {isPending ? (
                            <i className="mdi mdi-spin mdi-loading label-icon align-middle fs-16 me-2"></i>
                        ) : (
                            <i className="mdi mdi-check label-icon align-middle fs-16 me-2"></i>
                        )}

                        {t('button.clone')}
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default CloneModal
